import { h } from 'preact'; /** @jsx h */

import './VippsBanner.scss';

const VippsBanner = () => {
    return (
        <div className="vipps-banner-image-container">
            <div className="vipps-content-wrapper">
                <img
                    className="vipps-banner-image vipps-banner-logo"
                    src="https://norskluftambulanse.no/wp-content/uploads/2024/11/vipps-wink-rgb-negative.png"
                    alt=""
                    loading="lazy"
                />
                <img
                    className="vipps-banner-image vipps-banner-bubble"
                    src="https://norskluftambulanse.no/wp-content/uploads/2024/11/vipps-bubble.png"
                    alt=""
                    loading="lazy"
                />
            </div>
        </div>
    );
};

export default VippsBanner;
